import { css } from '@emotion/react'
import { unifiedColors } from './colors'
import { theme, themeUtils } from './theme'

export const globalStyle = css`
  * {
    -webkit-tap-highlight-color: transparent;
  }

  button {
    color: ${unifiedColors.label.default};
  }

  & .aa-Detached {
    width: 100%;
    overflow: auto;
  }

  & .processed-style {
    a {
      color: ${unifiedColors.label.default} !important;
      text-decoration: underline;
    }

    li {
      list-style-type: none;
      &:before {
        content: '●';
        margin-right: 4px;
      }
    }
  }

  body {
    ${themeUtils.body}
    position: relative;
    #cc-main {
      .cm__btn--close {
        svg {
          stroke: var(--cc-btn-secondary-color);
        }
        background: var(--cc-btn-secondary-bg);
        border: 1px solid var(--cc-btn-secondary-bg);
        :hover {
          svg {
            stroke: var(--cc-btn-secondary-color);
          }
          background: var(--cc-btn-secondary-hover-bg);
          border: 1px solid var(--cc-btn-secondary-hover-bg);
        }
      }
      --cc-btn-primary-bg: ${unifiedColors.button.primary.default};
      --cc-btn-primary-border-color: ${unifiedColors.button.primary.default};
      --cc-btn-primary-hover-bg: ${unifiedColors.button.primary.hovered};
      --cc-btn-primary-hover-border-color: ${unifiedColors.button.primary
        .hovered};
      --cc-btn-border-radius: 12px;
      --cc-toggle-on-bg: var(--cc-btn-primary-bg);
    }
    &.no-scroll {
      overflow: hidden;
    }
  }

  html {
    min-height: 100%;
    width: 100%;
  }

  html,
  body {
    /* overflow: auto; */
    margin: 0;
    padding: 0;
  }

  h1 {
    ${css({ ...(theme.typography.h1 as React.CSSProperties) })};
  }

  h2 {
    ${css({ ...(theme.typography.h2 as React.CSSProperties) })};
  }

  h3 {
    ${css({ ...(theme.typography.h3 as React.CSSProperties) })};
  }

  h4 {
    ${css({ ...(theme.typography.h4 as React.CSSProperties) })};
  }

  h5 {
    ${css({ ...(theme.typography.h5 as React.CSSProperties) })};
  }

  p {
    ${themeUtils.body}
  }

  .form-check-label {
    width: 95%;
  }
`
